import TopBar from "./TopBar";
import { Box } from "@mui/material";
import { ThemeProvider, createTheme } from "@mui/material";
import CssBaseline from '@mui/material/CssBaseline';
import { useState } from "react";
import { Outlet, useLocation } from 'react-router-dom';
import WipTextTheme from './WipTextTheme';
import * as React from 'react';
import CPFImmSook from '../fonts/CPF_Imm_Sook_Regular.ttf';
import Footer from "./Footer";


const ColorModeContext = React.createContext({ toggleColorMode: () => { } });

function MainLayout() {
  const { pathname } = useLocation();
  const isWip = /\/WIP(?:%20| )Tracking(?:\/|$)|\/wip-tracking(?:\/|$)/i.test(pathname)
    || (sessionStorage.getItem('master_std_plant') === '4179'
      && /^\/(list|new|edit)-master-std\/?$/.test(pathname));
  const [mode, setMode] = useState("light");
  const colorMode = React.useMemo(
    () => ({
      toggleColorMode: () => {
        setMode((prevMode) => (prevMode === 'light' ? 'dark' : 'light'));
      },
    }),
    [],
  );
  const theme = React.useMemo(
    () =>
      createTheme({
        palette: {
          //mode,
          background: {
            default: '#000000',
          },
        },
        typography: {
          fontFamily: "CPF_Imm_Sook"
        },
        components: {
          MuiCssBaseline: {
            styleOverrides: {
              "@font-face": {
                fontFamily: "CPF_Imm_Sook",
                src: `url(${CPFImmSook}) format("truetype")`
              },
            }
          }
        }
      }),
  );
  return (
    <>
      <ColorModeContext.Provider value={colorMode}>
        <ThemeProvider theme={theme}>
          <CssBaseline />
          <Box sx={{ backgroundColor: '#e0f2f1' }}>
            <TopBar />
            {isWip ? <WipTextTheme><Outlet /></WipTextTheme> : <Outlet />}
            <Footer />
          </Box>
        </ThemeProvider>
      </ColorModeContext.Provider>
    </>
  )
}

export default MainLayout
